import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { CompanyServiceRanking } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-company-service-rankings-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './company-service-rankings-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompanyServiceRankingsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private CompanyService: CompanyService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'CompanyServiceRanking';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id'],
      order: [['priorityLevel', 'ASC']]
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.CompanyService.getCompanyServiceRankings(queryObject),
          this.CompanyService.getCompanyServiceRankingCount(countQueryObject)
        ]).subscribe({
          next: ([CompanyServiceRankings, companyServiceRankingCount]: [
            CompanyServiceRanking[],
            number
          ]) => {
            params.success({
              rowData: CompanyServiceRankings,
              rowCount: companyServiceRankingCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
